import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, UserRound } from "lucide-react";
import { pageRoutes } from "../utils";

const loginOptions = [
  {
    title: "Member Login",
    description:
      "Members can sign in to view their dashboard, profile, membership status, and payment history.",
    to: pageRoutes.MemberLogin,
    icon: UserRound,
    action: "Continue as member",
  },
  {
    title: "Admin Login",
    description:
      "Admins and cashiers can sign in to review member registrations, donations, and church records.",
    to: pageRoutes.AdminLogin,
    icon: ShieldCheck,
    action: "Continue as admin",
  },
];

export default function Login() {
  return (
    <div className="min-h-screen bg-[#FDF8F3] px-4 py-16">
      <div className="mx-auto max-w-4xl">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-[0.22em] text-[#A88520]">
            Sign in
          </p>
          <h1 className="mt-3 font-serif-elegant text-4xl font-bold text-[#722F37] sm:text-5xl">
            Choose your login area
          </h1>
          <p className="mt-4 text-base leading-7 text-gray-700">
            Use Member Login for parish member accounts. Use Admin Login only if
            you have been given an admin or cashier account.
          </p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2">
          {loginOptions.map((option) => {
            const Icon = option.icon;

            return (
              <Link
                key={option.title}
                to={option.to}
                className="group flex h-full flex-col rounded-2xl border border-[#C9A227]/20 bg-white p-6 shadow-sm transition hover:-translate-y-0.5 hover:border-[#722F37]/30 hover:shadow-md"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#722F37]/10 text-[#722F37]">
                  <Icon className="h-6 w-6" />
                </div>
                <h2 className="mt-5 font-serif-elegant text-2xl font-bold text-[#722F37]">
                  {option.title}
                </h2>
                <p className="mt-3 flex-1 text-sm leading-6 text-gray-600">
                  {option.description}
                </p>
                <span className="mt-6 inline-flex items-center gap-2 font-semibold text-[#722F37]">
                  {option.action}
                  <ArrowRight className="h-4 w-4 transition group-hover:translate-x-1" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
